export enum CommonCustomerView {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}
export enum MigrationCustomerView {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}
